import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'opacity'
})
export class OpacityPipe implements PipeTransform {

  transform(value: string, opacity: number): unknown {
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return value + _opacity.toString(16).toUpperCase();
  }

}
